module.exports = __webpack_public_path__ + "img/7ead75674d2b3a15b467b942d0b3610d.png";